import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'

export default class CastingOptionsListTagComponent extends React.Component<StoreProps & { className?: string }, never> {
  render () {
    const { store, className, data: { selectedOptions } } = this.props

    return <ul className={ `listTag ${ className || '' }` }>
      { store.getSelectedOptionJoined().map((so, index) => {
        const required = so.offeredOption.option_type === 'product_catalogue'
          ? so.offeredOptionOfferedService.required_status !== 'no_required'
          : store.isOfferedOptionMandatory(so.offeredOption)

        return <li key={ index } className={ `listTag-element ${ required ? '' : 'with-close' }` }>
          { so.offeredOption.option_type === 'product_catalogue' ? so.offeredOptionOfferedService.offered_service.name : so.offeredOption.name }

          <span className="listTag-element-extra">{ store.formatSelectedOption(so) }</span>

          { !required && <button onClick={ () => store.set({ selectedOptions: selectedOptions.filter(_ => _ !== so.selectedOption) }) } className="listTag-close">
            <i className="icon icon-close"></i>
          </button> }
        </li>
      }) }
    </ul>
  }
}
